module.exports = __webpack_public_path__ + "img/txt.5cf93762.webp";